import { render, staticRenderFns } from "./ComparativoDeCategorias.vue?vue&type=template&id=4d0cc330"
import script from "./ComparativoDeCategorias.vue?vue&type=script&lang=js"
export * from "./ComparativoDeCategorias.vue?vue&type=script&lang=js"
import style0 from "./ComparativoDeCategorias.vue?vue&type=style&index=0&id=4d0cc330&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports